import { GridCheckCircleIcon } from '@mui/x-data-grid';
import { Calendar, Zap } from 'lucide-react';

export const PaymentToggler = ({ paymentType, setPaymentType }) => {
  return (
    <div className="w-full flex mt-6 gap-3 flex-col">
      {/* One Time Payment Option */}
      <div
        className={`flex-1 ${paymentType.oneTimePayment
          ? "bg-gradient-to-r from-[#2B2C54] to-[#3a3b6b] text-white shadow-lg border-2 border-[#ff8c00]"
          : "bg-[#f5f5f5] hover:bg-[#ebebeb] text-gray-700 border-2 border-transparent"
          } rounded-md relative transition-all duration-300 ease-in-out transform`}
      >
        {paymentType.oneTimePayment && <SelectedMark className="text-[#ff8c00] w-5 h-5" fill="currentColor" />}
        <button
          onClick={() => {
            setPaymentType({
              oneTimePayment: true,
              twoTimesPayment: false,
              threeTimesPayment: false,
            });
          }}
          className="py-4 px-5 text-left font-medium text-lg w-full flex items-start gap-3"
        >
          <div className={`mt-1 ${paymentType.oneTimePayment ? 'text-[#ff8c00]' : 'text-gray-500'}`}>
            <Zap size={24} />
          </div>
          <div className="flex-1">
            <span className="block font-semibold">One Time Payment</span>
            <span className={`mt-2 text-sm block font-normal ${paymentType.oneTimePayment ? 'text-gray-200' : 'text-gray-600'
              }`}>
              100% payment for the bootcamp. Get access to exclusive discounts and bonuses.
            </span>
          </div>
        </button>
      </div>

      {/* Two Times Payment Option */}
      <div
        className={`flex-1 ${paymentType.twoTimesPayment
          ? "bg-gradient-to-r from-[#2B2C54] to-[#3a3b6b] text-white shadow-lg border-2 border-[#ff8c00]"
          : "bg-[#f5f5f5] hover:bg-[#ebebeb] text-gray-700 border-2 border-transparent"
          } rounded-md relative transition-all duration-300 ease-in-out transform`}
      >
        {paymentType.twoTimesPayment && <SelectedMark className="text-[#ff8c00] w-5 h-5" fill="currentColor" />}
        <button
          onClick={() => {
            setPaymentType({
              oneTimePayment: false,
              twoTimesPayment: true,
              threeTimesPayment: false,
            });
          }}
          className="py-4 px-5 text-left font-medium text-lg w-full flex items-start gap-3"
        >
          <div className={`mt-1 ${paymentType.twoTimesPayment ? 'text-[#ff8c00]' : 'text-gray-500'}`}>
            <Calendar size={24} />
          </div>
          <div className="flex-1">
            <span className="block font-semibold">Pay Two Times</span>
            <span className={`mt-2 text-sm block font-normal ${paymentType.twoTimesPayment ? 'text-gray-200' : 'text-gray-600'
              }`}>
              Pay 50% now and complete the remaining balance within 75 days.
            </span>
          </div>
        </button>
      </div>
    </div>
  );
};

const SelectedMark = () => (
  <div className="absolute right-0 top-0">
    <GridCheckCircleIcon className="text-[#ff8c00] w-5 h-5" fill="currentColor absolute -right-2 -top-2" />
  </div>
);
